import { InteractionSummary } from "@/lib/messaging";
import { usePocketBase } from "@/context/pocketbase-context";
import { useQuery } from "@tanstack/react-query";

export interface InteractionsListResponse {
  totalCount: number;
  pages: number;
  page: number;
  period: string;
  language: string;
  data: InteractionSummary[];
}

const coreUrl = import.meta.env.VITE_REACT_APP_POCKETBASE_URL;

// Mock API function - replace with your actual API endpoint
const fetchInteractionList = async (
  page: number,
  size: number,
  period: string,
  language: string,
  mode: string,
  token: string
): Promise<InteractionsListResponse> => {
  const headers = new Headers();
  headers.append("Authorization", `Bearer ${token}`);

  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page.toString());
  if (size) queryParams.append("size", size.toString());
  if (period) queryParams.append("days_ago", period);
  if (period) queryParams.append("days_ago", period);
  if (language) queryParams.append("language_filter", language);
  if (mode) queryParams.append("mode_filter", mode);

  const response = await fetch(
    `${coreUrl}/api/interactions?` + queryParams.toString(),
    {
      method: "GET",
      headers: headers,
    }
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json() as Promise<InteractionsListResponse>;
};

export const useInteractionsList = (
  page: number,
  size: number,
  period: string,
  language: string,
  mode: string
) => {
  const { token } = usePocketBase();
  // const [pageNumber, setPageNumber] = useState(page);

  return useQuery({
    queryKey: ["interaction-list", period, language, mode, page],
    queryFn: () =>
      fetchInteractionList(page, size, period, language, mode, token),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
